var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    fill: "#ffffff",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "arrow-left-circle"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch Beta."), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-256 -1087)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m279 1102h-10.586l4.122-4.12c0.39-0.39 0.39-1.02 0-1.42-0.391-0.39-1.024-0.39-1.415 0l-5.657 5.66c-0.239 0.24-0.314 0.57-0.259 0.88-0.055 0.31 0.02 0.64 0.259 0.88l5.657 5.66c0.391 0.39 1.024 0.39 1.415 0 0.39-0.39 0.39-1.03 0-1.42l-4.122-4.12h10.586c0.552 0 1-0.45 1-1s-0.448-1-1-1zm-7 15c-7.732 0-14-6.27-14-14s6.268-14 14-14 14 6.27 14 14-6.268 14-14 14zm0-30c-8.836 0-16 7.16-16 16s7.164 16 16 16 16-7.16 16-16-7.164-16-16-16z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.fd710cd45823ff5e3a3bc5cb0f6616c9.svg";
export { ForwardRef as ReactComponent };